import { CheckoutArea, Area, ProgramCheckoutStore } from 'types/checkout';
import { IProgressStep, checkoutFlowRawFactory } from './program/step/lib/application.util';
import useCheckoutStore from './program/step/hooks/useCheckoutStore';
import { useEffect } from 'react';
import { i18n } from 'lib/i18n';

import { useRecoilState } from 'recoil';
import { stepsStore } from 'stores/checkoutSteps';

const PROGRAM_STEPS: IProgressStep[] = [
	'package',
	'schedule',
	'addons',
	{
		tabName: i18n.checkout.progress.familyMembers,
		urlPath: 'program/details',
	},
	'application',
	'payment',
];

export const useSteps = (area: Area) => {
	const { checkoutState } = useCheckoutStore();
	const [steps, setSteps] = useRecoilState(stepsStore.Steps);

	useEffect(() => {
		switch (area) {
			case 'program':
				setSteps(PROGRAM_STEPS);
				break;
			case 'rental':
				setSteps([
					{
						tabName: i18n.checkout.progress.schedule,
						urlPath: 'rental/schedule',
					},
					{
						tabName: i18n.checkout.progress.addons,
						urlPath: 'rental/addons',
					},
					{
						tabName: i18n.checkout.progress.application,
						urlPath: 'rental/application',
					},
					{
						tabName: i18n.checkout.progress.payment,
						urlPath: 'rental/payment',
					},
				]);
				break;
			case 'membership':
				setSteps([
					{
						tabName: i18n.checkout.progress.familyMembers,
						urlPath: 'membership/details',
					},
					{
						tabName: i18n.checkout.progress.application,
						urlPath: 'membership/application',
					},
					{
						tabName: i18n.checkout.progress.payment,
						urlPath: 'membership/payment',
					},
				]);
				break;
			case 'league':
				setSteps([
					'package',
					'addons',
					(checkoutState as ProgramCheckoutStore)?.selectedProduct?.productSubType === 'season_individual'
						? 'details'
						: 'teams',
					'application',
					'payment',
				]);
				break;
		}
	}, [checkoutState]); // eslint-disable-line react-hooks/exhaustive-deps

	return checkoutFlowRawFactory(CheckoutArea[area], steps, checkoutState);
};
